import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { customEvent } from "src/utils/gtag.js";
import CenterDialog from "./CenterDialog.js";

const GoogleConnectDialog = ({ open, onClose, user }) => {
  const handleEmailFounders = () => {
    customEvent({
      name: "user_click_email_founders_google_connect",
      category: "GoogleConnect",
      label: "Email Founders Button Click",
      data: {
        user_id: user?._id,
        user_email: user?.email,
        user_handle: user?.handle ?? "no_handle",
      },
    });
    window.open('mailto:founders@stanza.co?subject=Turn off Google Connect', '_blank');
    onClose();
  };

  return (
    <CenterDialog
      open={open}
      onClose={onClose}
      sx={{ height: "auto", ".MuiPaper-root": { maxWidth: "393px" } }}
      hideCloseButton
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: "393px",
          width: "100%",
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          textAlign: "left",
          padding: 2,
          pt: 3,
        }}
      >
        <Typography variant="title" sx={{ fontSize: "26px", textWrap: "pretty", mb: 3 }}>
          Turn off Google Connect
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 2 }}>
          To disable Google Connect, please email <strong>founders@stanza.co</strong> and we'll help you turn it off.
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
          We're working on building this functionality into the dashboard for easier management.
        </Typography>

        <Button
          variant="contained"
          onClick={handleEmailFounders}
          sx={{ 
            width: "100%"
          }}
        >
          EMAIL US
        </Button>
      </Box>
    </CenterDialog>
  );
};

export default GoogleConnectDialog;